import { render } from "./_form-daterange.vue?vue&type=template&id=6012b676"
import script from "./_form-daterange.vue?vue&type=script&lang=js"
export * from "./_form-daterange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__